/**
 * Procedure version UUID for Tables → Version History, AppBar titles, and comparison.
 * getAuditTrailByid often exposes `version_id` at root; some audits only nest refs.
 */
export function resolveAuditTrailVersionId(revData) {
  if (!revData || typeof revData !== "object") return null
  const vc = revData.version_content || {}
  const pvc = revData.parent_version_data?.version_content || {}
  return (
    revData.version_id ||
    vc.version_id ||
    vc.version_id_ref ||
    revData.parent_version_data?.version_id ||
    pvc.version_id ||
    pvc.version_id_ref ||
    null
  )
}
